"use client";
import MarkdownPreview from "@uiw/react-markdown-preview";
import { cloneElement } from "react";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import dayjs from "dayjs";
import { cn } from "@bearjb/ui/utils";

const MarkDown = ({ title, source, className }: any) => {
  const data = JSON.parse(source);
  const { date, tags } = data.data;

  // const postDate = dayjs(date).format("YYYY-MM-DD");

  return (
    <div className={cn("flex gap-10 w-full", className)}>
      <div className="flex flex-col w-full">
        {/* <h1 className="inline-flex items-center justify-center font-bold mb-6 text-size-3xl">
          {title}
        </h1> */}

        {/* <div className="flex items-center flex-col mb-8 gap-1 select-none">
          <time className="text-size-md text-gray-500">{postDate}</time>

          <div className="flex gap-2">
            {tags?.map((tag: string, i: number) => (
              <span
                key={i}
                className="p-1 rounded-md text-size-xs border border-gray-400  dark:border-gray-600 text-violet-600 dark:text-violet-600 hover:border-violet-600 dark:hover:border-violet-600 transition-all cursor-pointer"
              >
                {tag}
              </span>
            ))}
          </div>
        </div> */}

        <MarkdownPreview
          className="markdown-preview flex flex-col justify-center items-center" // 여기에 클래스 추가
          source={data.content}
          style={{
            background: "transparent",
          }}
          //   wrapperElement={{
          //     "data-color-mode": theme,
          //   }}
          components={{
            ol: ({ children }) => (
              <ol style={{ listStyleType: "decimal" }}>{children}</ol>
            ),
            ul: ({ children }) => (
              <ul style={{ paddingLeft: "1em", listStyleType: "disc" }}>
                {children}
              </ul>
            ),
            li: ({ children }) => <li className="text-size-sm">{children}</li>,
            h1: ({ children }) => <h1 className="text-size-3xl">{children}</h1>,
            h2: ({ children }) => <h2 className="text-size-2xl">{children}</h2>,
            h3: ({ children }) => <h3 className="text-lg">{children}</h3>,
            p: ({ children }) => (
              <p className="text-size-sm dark:text-[#d1d5db]">{children}</p>
            ),
            img: ({ children, src, alt }) => (
              <>
                <img className="mt-4 mb-2 flex rounded-sm" src={src}>
                  {children}
                </img>
                <em className="text-size-xs">{alt}</em>
              </>
            ),
            code: ({ children, className, node }: any) => {
              const isDiffArray = ["object", "string"];
              if (isDiffArray.includes(typeof children)) {
                return <code className={className}>{children}</code>;
              }

              const childrenWithProps = children.map((item: JSX.Element) => {
                return cloneElement(item, {
                  className: cn("whitespace-pre-wrap", item.props.className),
                });
              });

              return <code className={className}>{childrenWithProps}</code>;
            },
          }}
          remarkPlugins={[remarkGfm, remarkBreaks]}
          rehypePlugins={[rehypeRaw]}
          rehypeRewrite={(node: any, index, parent) => {
            if (node.tagName === "img") {
              node.properties.src = `${process.env.NEXT_PUBLIC_BLOG_CF_ENDPOINT}/files/${node.properties.src}`;
            }
          }}
        />
      </div>
    </div>
  );
};

export default MarkDown;
